import { useStore } from "react-redux";
import useRefreshTokenBase from "@wine2trace/auth/useRefreshToken";
import axios from "../api/axios";
import useEndSession from "./useEndSession";
import { selectActiveWinery } from "../context/selectors";

// Refresh dell'access token (@wine2trace/auth) con l'header della cantina attiva.
// `refresh` e' stabile e single-flight per tab.
const useRefreshToken = () => {
  const store = useStore();
  const endSession = useEndSession();

  // cantina attiva letta dallo store al momento della chiamata (non dal render):
  // dopo l'uscita dall'impersonazione non deve partire quella del target
  // Uscita da un'impersonazione (impersonation presente): la cantina e' del
  // target, il refresh e' dell'admin e non deve portarla.
  const getRefreshHeaders = ({ impersonation } = {}) => {
    const activeWinery = impersonation ? null : selectActiveWinery(store.getState());
    return activeWinery ? { clientname: activeWinery?.client_name } : {};
  };

  return useRefreshTokenBase({ api: axios, getRefreshHeaders, endSession });
};

export default useRefreshToken;
